module.exports = __webpack_public_path__ + "images/5960251dd6a1ca89cb051cac7a3e3f6c.jpg";